import yaml from 'js-yaml';

export type MasterConfigDoc = Record<string, unknown>;

export function parseMasterYaml(content: string): MasterConfigDoc {
  const parsed = yaml.load(content);
  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
    throw new Error('Master YAML must be a mapping at the root');
  }
  return parsed as MasterConfigDoc;
}

export function masterDocToYaml(doc: MasterConfigDoc): string {
  return yaml.dump(doc, { lineWidth: 120, noRefs: true, skipInvalid: true });
}

export {
  cloneDoc,
  ensureObject,
  ensureArray,
  asString,
  asBool,
  asNumber,
  stringList,
  objectMap,
  objectRecord,
} from './tenant-config-form-utils';
